import MetricEventTypes from "@Enums/MetricEventTypes";
import MetricFilterTypes from "@Enums/MetricFilterTypes";

export type MetricLabel = {
  name: string;
  long: string;
  short: string;
};

const metricLabels: Record<string, MetricLabel> = {
  [MetricFilterTypes.BYB_IQ]: {
    name: "metric.byb_iq.name",
    long: "metric.byb_iq.long",
    short: "metric.byb_iq.short",
  },
  [MetricFilterTypes.GAMEPLAY_DURATION]: {
    name: "metric.gameplay_duration.name",
    long: "metric.gameplay_duration.long",
    short: "metric.gameplay_duration.short",
  },
  [MetricEventTypes.SCAN_FREQUENCY]: {
    name: "metric.scan_rate.name",
    long: "metric.scan_rate.long",
    short: "metric.scan_rate.short",
  },
  [MetricEventTypes.SCAN_TIMING]: {
    name: "metric.scan_timing.name",
    long: "metric.scan_timing.long",
    short: "metric.scan_timing.short",
  },
  [MetricEventTypes.CRITICAL_SCAN]: {
    name: "metric.critical_scan.name",
    long: "metric.critical_scan.long",
    short: "metric.critical_scan.short",
  },
  [MetricEventTypes.AWARENESS]: {
    name: "metric.awareness.name",
    long: "metric.awareness.long",
    short: "metric.awareness.short",
  },
  [MetricEventTypes.DECISION]: {
    name: "metric.passes_score.name",
    long: "metric.passes_score.long",
    short: "metric.passes_score.short",
  },
};

const defaultMetricLabel: MetricLabel = {
  name: "metric.score.name",
  long: "metric.score.long",
  short: "metric.score.short",
};

const getMetricLabel = (metricName: string): MetricLabel => {
  return metricLabels[metricName.toUpperCase()] || defaultMetricLabel;
};

export default getMetricLabel;
